export default "__VITE_ASSET__skXJ15E4__"